import { motion } from "framer-motion";
import { HeartHandshake } from "lucide-react";

export const VolunteerIntroScreen = ({ onNext }) => (
  <div data-testid="volunteer-intro-screen" className="flex-1 flex flex-col items-center justify-center px-6 py-10 text-center">
    <motion.div
      initial={{ scale: 0, rotate: -15 }}
      animate={{ scale: 1, rotate: 0 }}
      transition={{ type: "spring", stiffness: 200, damping: 15 }}
      className="flex h-20 w-20 items-center justify-center rounded-full border-2 border-pink-400 bg-white shadow-[0_0_24px_rgba(236,72,153,0.4)]"
    >
      <HeartHandshake size={36} className="text-cyan-500" />
    </motion.div>

    <motion.h2
      className="font-display mt-6 text-3xl sm:text-4xl font-black uppercase tracking-tight"
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.15 }}
    >
      Help Our{" "}
      <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-500 to-yellow-400">
        Eagles Soar!
      </span>
    </motion.h2>

    <motion.p
      className="mt-4 max-w-sm text-base sm:text-lg leading-relaxed text-slate-600"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.3 }}
    >
      Before we get you those <span className="font-bold text-pink-600">50 entries</span>, we'd love to know
      how you might want to get involved with the PTA this year! No commitments right now—we are just gauging
      your interests to help us plan.
    </motion.p>

    <motion.div
      className="mt-5 flex items-center gap-2.5"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.4 }}
      aria-hidden="true"
    >
      <span className="h-2.5 w-2.5 rounded-full bg-cyan-400 shadow-[0_0_8px_rgba(6,182,212,0.8)]" />
      <span className="h-2.5 w-2.5 rounded-full bg-pink-500 shadow-[0_0_8px_rgba(236,72,153,0.8)]" />
      <span className="h-2.5 w-2.5 rounded-full bg-yellow-400 shadow-[0_0_8px_rgba(234,179,8,0.8)]" />
    </motion.div>

    <motion.button
      data-testid="volunteer-intro-next-button"
      onClick={onNext}
      className="mt-8 w-full rounded-2xl border-2 border-pink-500 bg-white px-6 py-5 font-display text-lg font-black uppercase tracking-wide text-slate-900 shadow-[0_0_18px_rgba(236,72,153,0.35)] transition-colors hover:bg-pink-50 active:scale-[0.97]"
      initial={{ opacity: 0, y: 14 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.5 }}
      whileTap={{ scale: 0.97 }}
    >
      Show Me the Options!
    </motion.button>
  </div>
);
